<template>
    <div class="layout-search">
        <input type="text" ref="search" @keyup.enter="search" :placeholder="placeholder">
        <icon name="magnify" @click="search"/>
    </div>
</template>

<style lang="scss">
    .layout-search {
        position: relative;

        input {
            display: block;
            width: 100%;
            height: 35px;
            padding: 0 40px 0 $spacer-2;
            background-color: $dark-5;
            border: 1px solid $dark-5;
            border-radius: 0;
            font-size: $font-size-sm;

            &:focus {
                outline: none;
                background-color: $white;
            }
        }
        .mdi {
            position: absolute;
            top: 0;
            right: 0;
            font-size: 20px;
            line-height: 35px;
            width: 35px;
            height: 35px;
            text-align: center;
            background-color: $yellow;
        }
    }
</style>

<script>
    export default {
        props: {
            placeholder: {type: String, default: 'Suchen...'},
        },
        methods: {
            search() {
                let search = this.$refs.search.value;
                if (search.length > 0) {
                    this.$ui.pushRoute('community_search', {encoded_search_term: encodeURIComponent(search)});
                }
            },
        },
    };
</script>